import type { HttpClient } from '@shared/http/http-client';
import type { ILabAdminRepository } from '@domain/data-contracts/lab-admin-repository.interface';
import type { Lab } from '@domain/models/lab.interface';

interface LabDto {
  readonly labId: number;
  readonly name: string;
  readonly isActive: boolean;
}

function mapLabDto(dto: LabDto): Lab {
  return {
    id: String(dto.labId),
    name: dto.name,
    isActive: dto.isActive,
  };
}

export class LabAdminRepository implements ILabAdminRepository {
  public constructor(private readonly http: HttpClient) {}

  public async listAll(signal?: AbortSignal): Promise<readonly Lab[]> {
    const response = await this.http.get<readonly LabDto[]>('/api/admin/labs', { signal });
    return response.data.map(mapLabDto);
  }
}
